export const API_URL = "/api"
export const PAGE_SIZE = 20

export const NAMED_ENTITY_TYPES = [
  { value: "AUTHOR", label: "Autore" },
]
